module.exports = __webpack_public_path__ + "static/104.5e450574.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshots/104.png
// module id = 470
// module chunks = 35783957827783